import React from "react";
import { Search, X } from "lucide-react";

interface UserSearchBarProps {
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClearSearch: () => void;
  totalUserCount: number;
  debouncedSearchTerm: string;
  placeholder?: string;
}

export default function UserSearchBar({
  searchTerm,
  onSearchChange,
  onKeyPress,
  onClearSearch,
  totalUserCount,
  debouncedSearchTerm,
  placeholder = "이름, 이메일, 연락처로 검색..."
}: UserSearchBarProps) {
  return (
    <div className="bg-slate-900 rounded-xl border border-slate-800 p-6 mb-6">
      <div className="flex flex-col lg:flex-row gap-4">
        {/* 검색바 */}
        <div className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" />
            <input
              type="text"
              placeholder={placeholder}
              value={searchTerm}
              onChange={onSearchChange}
              onKeyPress={onKeyPress}
              className="w-full pl-10 pr-4 py-3 bg-slate-800 border border-slate-700 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all"
            />
            {searchTerm && (
              <X
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5 cursor-pointer"
                onClick={onClearSearch}
              />
            )}
          </div>
        </div>
      </div>

      {/* 검색 결과 정보 */}
      <div className="mt-4">
        <p className="text-slate-400 text-sm">
          총{" "}
          <span className="text-white font-medium">{totalUserCount}</span>
          명의 사용자
          {debouncedSearchTerm && (
            <span className="ml-2 text-purple-400">
              ('{debouncedSearchTerm}' 검색 결과)
            </span>
          )}
        </p>
      </div>
    </div>
  );
}